import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "src/app/services/auth/auth.service";
import { Config } from "src/app/services/auth/Config";
import { LoggedInService } from "../loggedin.service";
 
@Injectable({
    providedIn: 'root'
  })
export class LoggedinGuard implements CanActivate {
 
    private config: Config;
    private environment: any
 
    constructor(private http: HttpClient, private router: Router, private authService: AuthService, private loggedInService: LoggedInService,) {
        this.config = new Config();       
     }
 
    queryParamExists(param: string, route: ActivatedRouteSnapshot): boolean {
        const params = Object.keys(route.queryParams);
        return params.length > 0 && params.includes(param);
    }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.queryParamExists('code', route)) {
            return this.authService.isAuthenticated(route.queryParams["code"]);
        }

        if (document.cookie.indexOf("session") < 0) {
            this.loggedInService.redirectToPing();
            return false;
        }

        if (this.authService.localstorageContainsToken()) {
            this.loggedInService.redirectToPing();
            return false;
        }

        this.loggedInService.syncTokenContentFromSession();

        return this.authService.ensureMenuLoaded();
    }
}
